import React, { useEffect } from "react";
import PropTypes from "prop-types";
/* components */
import WidgetWrap from "@components_v2/dashboard/ui/widget-wrapper";
import WidgetHead from "@components_v2/dashboard/ui/widget-head";
import { useDispatch, useSelector } from "react-redux";
import { getWidgetData } from "@modules/dashboard";
import { IconRefresh } from "@mzc-cloudplex/icons";
import { CircularProgress, Grid, Stack } from "@mzc-pdc/ui";
import theme from "@styles/theme";
import { Typography } from "@mui/material";

const ZendeskNotice = ({
    id,
    name,
    title,
    icon,
    color,
    widgets,
    onMove,
    onDelete,
    fullWidth,
    blockDrag,
    logo,
    viewAllUrl,
    params,
    isNotice,
    type,
}) => {
    const dispatch = useDispatch();

    const { widgetData } = useSelector(({ dashboard }) => ({
        widgetData: dashboard.dashboardWidgetData?.find((widget) => widget.id === id),
    }));

    useEffect(() => {
        dispatch(getWidgetData({ id, params }));
    }, []);

    //draggable같이 알아듣기 쉬운 속성으로 wrap에 넘겨주기
    return (
        <WidgetWrap id={name} onMove={onMove} fullWidth={fullWidth} blockDrag={blockDrag} isNotice={isNotice}>
            <Grid container flexDirection={"column"} flex={1} height={"100%"}>
                <Grid item sx={{ borderBottom: `1px solid ${theme.palette.greySecondary[100]}` }}>
                    <WidgetHead
                        onRefresh={() => dispatch(getWidgetData({ id, params }))}
                        title={title}
                        icon={icon}
                        name={name}
                        color={color}
                        widgets={widgets}
                        onDelete={onDelete}
                        externalLink={viewAllUrl}
                    />
                </Grid>
                <Grid item flex={1} width={1} sx={{ overflowY: "auto" }}>
                    <Grid container flexDirection={"row"} flexWrap={"nowrap"} gap={2.5} p={2.5}>
                        {logo && (
                            <Grid item>
                                <div className={`logo`}>
                                    <img src={logo} alt="logo" width={100} height={100} />
                                </div>
                            </Grid>
                        )}
                        <Grid item flex={1} height={1}>
                            {widgetData && widgetData.pending && (
                                <Grid container width={1} height={1} alignContent={"center"} justifyContent={"center"}>
                                    <CircularProgress size={40} color="greySecondary" />
                                </Grid>
                            )}
                            <Stack gap={2}>
                                {widgetData &&
                                    widgetData.data?.map((text, index) => (
                                        <Grid
                                            container
                                            key={`${id}-${index}`}
                                            component={"a"}
                                            href={text.html_url}
                                            target="_blank"
                                            gap={1.5}
                                            sx={{
                                                "&:hover": {
                                                    textDecoration: "none",
                                                },
                                            }}
                                        >
                                            <Grid item xs zeroMinWidth maxWidth={`60%`}>
                                                <Typography variant="body1" noWrap>
                                                    {text.title}
                                                </Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant="body1" color={"text.secondary"}>
                                                    {text.updated_at
                                                        ? new Date(text.updated_at)?.toISOString()?.split("T")?.[0]
                                                        : ""}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    ))}
                            </Stack>
                            {/* <div className={`list-notice`}>
                                {widgetData && widgetData.pending && (
                                    <span className={"loading"}>
                                        <i className={"loading-content"} />
                                    </span>
                                )}
                                <ul>
                                    {widgetData &&
                                        widgetData.data?.results?.map((text, index) => (
                                            <li key={`${id}-${index}`}>
                                                <a href={text.html_url} target="_blank">
                                                    <span className={`text-default`}>{text.title}</span>
                                                    <span className={`text-secondary`}>
                                                        {text.updated_at
                                                            ? new Date(text.updated_at)?.toISOString()?.split("T")?.[0]
                                                            : ""}
                                                    </span>
                                                </a>
                                            </li>
                                        ))}
                                </ul>
                            </div> */}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </WidgetWrap>
    );
};

ZendeskNotice.propTypes = {
    user: PropTypes.object,
    name: PropTypes.string,
    title: PropTypes.string,
    icon: PropTypes.node,
    widgets: PropTypes.array,
    onMove: PropTypes.func,
    onDelete: PropTypes.func,
};

export default ZendeskNotice;
